export default __webpack_public_path__ + "static/bnp-logo-d20dfea8dfc46b5cc3ea5274dff43b17.svg";